import { render, staticRenderFns } from "./CheckHouseBlPop.vue?vue&type=template&id=596fbede&scoped=true"
import script from "./CheckHouseBlPop.vue?vue&type=script&lang=js"
export * from "./CheckHouseBlPop.vue?vue&type=script&lang=js"
import style0 from "./CheckHouseBlPop.vue?vue&type=style&index=0&id=596fbede&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596fbede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596fbede')) {
      api.createRecord('596fbede', component.options)
    } else {
      api.reload('596fbede', component.options)
    }
    module.hot.accept("./CheckHouseBlPop.vue?vue&type=template&id=596fbede&scoped=true", function () {
      api.rerender('596fbede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CheckHouseBlPop.vue"
export default component.exports